import Postel from '@/assets/companies/postel/sidebar-logo.svg?react';
import { DesignCompany } from '@/providers';
import { ReactNode } from 'react';
import { DefaultSidebarLogo } from '../layout/Sidebars/sidebar';

export const RESET_PASSWORD_LOGOS: Record<DesignCompany, ReactNode> = {
  audiencerate: <DefaultSidebarLogo />,
  postel: <Postel className='w-[7.5rem]' />,
};
